import { render, staticRenderFns } from "./m-assign-new-class.vue?vue&type=template&id=1a1eb902&scoped=true&"
import script from "./m-assign-new-class.ts?vue&type=script&lang=ts&"
export * from "./m-assign-new-class.ts?vue&type=script&lang=ts&"
import style0 from "./m-assign-new-class.scss?vue&type=style&index=0&id=1a1eb902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1eb902",
  null
  
)

export default component.exports